import { parseTerms } from "./parseTerms";
import { lang } from "./../app";
export const initializeReleaseSearch = () => {
	$("#release_search").on("submit", function (e) {
		e.preventDefault();
		let values = {};
		$(this)
			.serializeArray()
			.forEach(value => {
				values[value.name] = value.value;
			});
		let terms = parseTerms(values.terms);
		// values.terms is a string of the raw form input;
		// helper function returns array
		// of "quoted strings" separated from naked terms

		let search = `?${terms.length ? `q=${terms.map(term => encodeURIComponent(term)).join(";")}` : ""}`;
		if (values.tag) {
			search += `${terms.length ? "&" : ""}tag=${values.tag}`;
		}
		if (values.year) {
			search += `${terms.length || values.tag ? "&" : ""}year=${values.year}`;
		}
		if (values.dark_items) {
			search += `${terms.length || values.tag || values.year ? "&" : ""}dark=true`;
		}

		location.href = `/${lang}/search/${search}`;
		// reroute to search page with prepped terms
	});
};
// end initializeReleaseSearch function
